import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { NextSeo } from 'next-seo';
import { DEFAULT_IMAGE } from 'constants/global';
import { getBriefTitle, getBriefDescription } from 'constants/brief.helpers';
import { truncate } from 'lodash';

var SeoComponent = function SeoComponent(_ref) {
  var space = _ref.space,
      channel = _ref.channel,
      user = _ref.user,
      brief = _ref.brief;
  var Seo = useMemo(function () {
    var title = '';
    var description = '';
    var image = '';

    if (space) {
      image = space.image;
      title = space.company;
      description = space.description;
    } else if (channel) {
      image = channel.image;
      title = channel.title;
      description = channel.description;
    } else if (user) {
      title = "".concat(user.firstName, " ").concat(user.lastName);
      image = user.image;
      description = user.bio;
    }

    if (brief) {
      image = brief.content.image;
      title = getBriefTitle(brief);
      description = getBriefDescription(brief);
    }

    if (!image || image === 'image') {
      image = DEFAULT_IMAGE;
    }

    var seoProp = {
      title: title,
      description: truncate(description, {
        length: 160
      }),
      image: image
    }; //console.log('🚀 ~ Seo ~ seoProp', seoProp);

    return seoProp;
  }, [space, channel, user, brief]);
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx(NextSeo, {
      title: Seo.title,
      description: Seo.description //canonical="https://www.canonical.ie/"
      ,
      openGraph: {
        //url: 'https://www.url.ie/a',
        title: Seo.title,
        description: Seo.description,
        images: [{
          url: Seo.image
        }]
      },
      twitter: {
        handle: '@handle',
        site: '@site',
        cardType: 'summary_large_image'
      }
    })
  });
  return null;
};

export default SeoComponent;